let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8Lbxy")).then(() => parcelRequire('fb8sc'));